import React from "react";

const CFDWhitepaperPage = () => {
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <iframe
        title="CFD Whitepaper"
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        src="https://www.canva.com/design/DAGlPuHh3qc/HgQ6avgNOSjpfuEOQsulxQ/view?embed"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default CFDWhitepaperPage;